import { render, staticRenderFns } from "./subject2.vue?vue&type=template&id=7b43e9b4&scoped=true&"
import script from "./subject2.vue?vue&type=script&lang=js&"
export * from "./subject2.vue?vue&type=script&lang=js&"
import style0 from "./subject2.vue?vue&type=style&index=0&id=7b43e9b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b43e9b4",
  null
  
)

export default component.exports